module.exports = __webpack_public_path__ + "static/media/ico-phone-perfil.414aa584.svg";